var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg12PxStar = function Svg12PxStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.237.897 1.479 2.996 3.307.481a.265.265 0 0 1 .147.451L8.777 7.158l.565 3.294a.265.265 0 0 1-.384.279L6 9.176l-2.958 1.555a.265.265 0 0 1-.384-.279l.565-3.294L.83 4.825a.264.264 0 0 1 .147-.451l3.307-.481L5.763.897a.264.264 0 0 1 .474 0"
  })));
};
export default Svg12PxStar;